<template>
  <div
    :class="['zg-card', {
      [`zg-card--background-${background}`]: background
    }]"
  >
    <zg-label
      v-if="label"
      :text="label"
      class="label"
    />

    <div
      v-if="image"
      class="image"
    >
      <zg-image
        v-bind="image"
        lazy-load
      />
    </div>

    <div class="content">
      <h4 v-if="title">
        {{ title }}
      </h4>

      <slot
        v-if="$slots['text-content']"
        name="text-content"
      />

      <div
        v-else
        v-html="text"
      />
    </div>

    <zg-button-link
      v-if="link && link.href && link.text"
      :href="link.href"
      :text="link.text"
      :button-props="{
        icons: { right: 'arrow-forward' },
        link: true
      }"
    />
  </div>
</template>

<script>
  import ZgButtonLink from '../ZgButtonLink/ZgButtonLink'
  import ZgImage from '../ZgImage/ZgImage'
  import ZgLabel from '../ZgLabel/ZgLabel'

  export default {
    name: 'ZgCard',
    components: {
      ZgButtonLink,
      ZgImage,
      ZgLabel
    },
    props: {
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      },
      label: {
        type: String,
        required: false,
        default: null
      },
      image: {
        type: Object,
        default: null,
        validator: image => image?.src
      },
      title: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
      link: {
        type: Object,
        default: null,
        validator: (link) => link.text && link.href
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-card {
    width: 100%;
    height: auto;
    padding: rhythm();
    border-radius: radius(large);

    .label {
      margin: 0 0 rhythm(small);
    }

    .image {
      width: 100%;
      height: auto;
      max-height: rem(300px);
      overflow: hidden;
      border-radius: radius(small);
      margin: 0 0 rhythm();
    }

    .content {
      position: relative;
      margin: 0 0 rhythm(small);

      h4 {
        @include type-title-m;
      }

      ::v-deep p:last-child {
        margin: 0;
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-card--background-white {
    background-color: color(white);
  }

  .zg-card--background-beige {
    background-color: color(beige);
  }
</style>
